const randomKey = () => Math.random().toString(16).substring(2, 8);

export default randomKey;
